import { Button, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { IMenuOption, IMoveToSellOutPostData, ISwimlaneMaster } from "models/interfaces";
import React, { useState } from "react";
import { PurchaseAndShippingService } from "services/SkyboxServices";
import { LoggerService } from "sharedServices";
import { formatThousandSeparator } from "utils/commonFunction";
const target_swimlane_id = 5;

const MoveToSellOutShipping: React.FC<{ 
  menuData: IMenuOption;
  invoice_id: number;
  swimlaneData: ISwimlaneMaster;
  setShowMenu: Function;
  handleMenuSelection: Function;
  selectedMenuId: number | null;
  setSelectedMenuId: Function;
  requestToReloadTheLanes: Function;
}> = ({ menuData, invoice_id, swimlaneData, setShowMenu, handleMenuSelection, selectedMenuId, setSelectedMenuId, requestToReloadTheLanes }) => {

  const [moveToSellOutData, setMoveToSellOutData] = useState<IMoveToSellOutPostData>({
    invoice_id: invoice_id,
    swimlane_id: target_swimlane_id,
    notes: null,
  });
  const notesChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMoveToSellOutData((prev) => ({
      ...prev,
      notes: e.currentTarget.value,
    }));
  };

  const submitMovedToNeedToBuy = async () =>{
    const moveNeedToBuyKey = "moveNeedToBuyKey";
    setSelectedMenuId(null);
    setShowMenu(false);
    message.loading({
      content: `Moving Invoice from ${swimlaneData.name} to Sell-Out queue...`,
      duration: 0,
      key: moveNeedToBuyKey,
      className: "toastMsg loadingMsg",
    });

    try {
      await new PurchaseAndShippingService().moveToSellOutShipping(moveToSellOutData);
      requestToReloadTheLanes([swimlaneData.id, target_swimlane_id]);
      message.success({
        content: `Invoice #${invoice_id} is moved to Sell-Out queue`,
        duration: 5,
        key: moveNeedToBuyKey,
        className: "toastMsg savedSuccess",
      });

    } catch (error: any) {
      new LoggerService().log({
        payload: error,
        function_name: "submitMovedToNeedToBuy",
      });
      message.error({
        key: moveNeedToBuyKey,
        content: "Failed to update.",
        duration: 5,
        className: "toastMsg savedFailed",
      });
    }
  }

  return (
    <React.Fragment>
      <div className="accHead" onClick={()=>{
        if (selectedMenuId === menuData.menu_id) {
          handleMenuSelection(null);
          setMoveToSellOutData((prev) => ({
            ...prev,
            notes: null,
          }));
        } else {
          handleMenuSelection(menuData.menu_id);
        }
      }}>{menuData.name}</div>
      <div className="accBody">
        <div className="moveOnSaleWrap">
        <div className="moveOnSaleRow">
            <TextArea
              maxLength={1000}
              showCount={{
                formatter: ({ count, maxLength }) =>
                  maxLength ?
                    `${formatThousandSeparator((maxLength ?? 0) - count)} Remaining` :
                    "",
              }}
              placeholder="Note"
              className="moveToIssuesTxtArea"
              rows={4}
              value={moveToSellOutData?.notes ? moveToSellOutData.notes : ""}
              onChange={notesChangeHandler}
              allowClear
              autoSize={{ minRows: 4, maxRows: 4 }}
            />
          </div>
          <div className="moveOnSaleRow btnGroupFooter">
            <Button className="discardBtn" onClick={() => {
              setSelectedMenuId(null);
              setMoveToSellOutData((prev) => ({
                ...prev,
                notes: null,
              }));
            }}>
              <span>CANCEL</span>
            </Button>
            <Button
              className="btnUpdate"
              onClick={submitMovedToNeedToBuy}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MoveToSellOutShipping;

